import * as Common from "../../commons/common"

export class SheetListCondition{
  lesson_code: string = ""
  lesson_class_no: string = ""
  nendo: number = null
  subject_code: string = null
  saiten_flg: string = ""
  page: number = 1
  row_count: number =  Common.SheetListRowCount
}

export interface LessonClassSheet{
	lesson_class_id: number
	lesson_code: string
	nendo: number
	lesson_class_no: number
	lesson_name: string
	subject_code: string
	questionnaire_group_id: number
	kyouzai_student_count: number
	test_sheet_id: number
	test_student_count: number
	test_mi_saiten_count: number
	test_submitted_at: Date
	test_saiten_flg: boolean
	full_count: number
}